import axiosInstance, { EVENT_CODE, EVENT_ID, F_EMAIL, getUserID, SPEAKERSUBMIT_TEMPLATE, WEB_API } from '../constatns';
import swal from '@sweetalert/with-react';
import UploadToS3 from '../common/UploadToS3';

export const speakerAction = (_state, _mode, _id, isSubmitting, isComplete) => {
  return new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append('evt', EVENT_ID);
    formData.append('evtCode', EVENT_CODE.replace('#', ''));
    // if (_mode === 'write') {
    //   formData.append('writer', getUserID(true).replace(EVENT_ID + '_', ''));
    // } else {
    //   formData.append('writer', _state.email);
    // }
    // formData.append('isForeigner', _state.isForeigner);

    //for SendEmail
    formData.append('from', F_EMAIL);
    formData.append('title', sessionStorage.getItem('_in_title'));
    formData.append('templateName', SPEAKERSUBMIT_TEMPLATE);

    if (isComplete) {
      formData.append('status', 'Complete');
    }

    const lang = _state.lang;

    for (const [key, value] of Object.entries(_state)) {
      if (
        key === 'country' ||
        key === 'isForeigner' ||
        key === 'firstName' ||
        key === 'lastName' ||
        key === 'affiliation' ||
        key === 'countryCode' ||
        key === 'phoneNumber' ||
        key === 'session' ||
        key === 'noteTitle' ||
        key === 'noteContent' ||
        key === 'korCheckisGet' ||
        key === 'korCheckNoGet' ||
        key === 'checkVod' ||
        key === 'isUseLaptop' ||
        key === 'checkVodNone'
      ) {
        formData.append(key, value);
      }
      if (key === 'email') {
        formData.append(key, value);
        formData.append('writer', value);
      }
      if (
        lang === 'kor' &&
        (key === 'accountHolder' ||
          key === 'bank' ||
          key === 'bankAccount' ||
          key === 'check1' ||
          key === 'check2' ||
          key === 'check2None' ||
          key === 'check3' ||
          key === 'check3None')
      ) {
        formData.append(key, value);
      }
    }

    if (_mode === 'write') {
      //figures memo
      for (let i = 0; i < _state.figuresMemo.length; i++) {
        formData.append(`figuresMemo${i + 1}`, _state.figuresMemo[i]);
      }

      axiosInstance
        .post(`${WEB_API}/speaker/`, formData, {
          'Content-Type': 'multipart/form-data',
        })
        .then((res) => {
          speakerFileUpload(res.data.speakerId, _state, _mode).then((fileFormData) => {
            axiosInstance
              .post(`${WEB_API}/speaker/mod`, fileFormData, {
                'Content-Type': 'multipart/form-data',
              })
              .then((res) => {
                resolve(res);
              })
              .catch((err) => {
                console.error(err);
                reject(err);
              });
          });
        })
        .catch((error) => {
          console.error(error);
          swal('Error occurred while posting your submission. Please retry it.');
          reject(error);
        });
    }
    if (_mode === 'modify') {
      //figures memo
      if (isSubmitting) {
        for (let i = 1; i <= 4; i++) {
          if (_state.data[`figuresMemo${i}`] && _state.data[`figuresMemo${i}`] !== '') {
            formData.append(`figuresMemo${i}`, _state.data[`figuresMemo${i}`]);
          }
        }
      } else {
        for (let i = 0; i < 4; i++) {
          if (_state.figuresMemo[i] && _state.figuresMemo[i] !== '') {
            formData.append(`figuresMemo${i + 1}`, _state.figuresMemo[i]);
          } else if ((_state.figuresMemo[i] === '' || !_state.figuresMemo[i]) && _state.figuresMemo[i] !== '') {
            formData.append(`figuresMemo${i + 1}`, '');
          }
        }
      }

      formData.append('speakerId', _id);
      // formData.append('writer', _state.writer);
      axiosInstance
        .post(`${WEB_API}/speaker/mod`, formData, {
          'Content-Type': 'multipart/form-data',
        })
        .then((_res) => {
          speakerFileUpload(_id, _state, _mode, isSubmitting).then((fileFormData) => {
            axiosInstance
              .post(`${WEB_API}/speaker/mod`, fileFormData, {
                'Content-Type': 'multipart/form-data',
              })
              .then((res) => {
                resolve(res);
              })
              .catch((err) => {
                console.error(err);
                reject(err);
              });
          });
        })
        .catch((error) => {
          // console.error(error);
          swal('Error occurred while posting your submission. Please retry it.');
          reject(error);
        });
    }
  });
};

export const speakerFileUpload = async (speakerId, _state, _mode, isSubmitting) => {
  const fileFormData = new FormData();
  fileFormData.append('evt', EVENT_ID);
  fileFormData.append('speakerId', speakerId);

  let state = isSubmitting ? _state.data : _state;

  let idx = 0;
  let maxFile = 0;

  if (isSubmitting) {
    for (let i = 0; i < 4; i++) {
      if (state[`figures${i + 1}`] !== '') {
        if (state[`figures${i + 1}`] instanceof File) {
          maxFile++;
        }
      }
    }
  } else {
    for (let i = 0; i < state.figures.length; i++) {
      if (state.figures[i] !== '') {
        if (state.figures[i] instanceof File) {
          maxFile++;
        }
      }
    }
  }

  return new Promise(async (resolve, reject) => {
    if (!state.cvfile && maxFile === 0) resolve(fileFormData);
    if (state.cvfile !== '' && state.cvfile instanceof File) {
      maxFile++;
      await UploadToS3(state.cvfile, 'PRS2021/speaker', speakerId).then((_upload) => {
        fileFormData.append(`cvfile_DUP`, JSON.stringify(_upload));
        idx++;
      });
    }

    if (isSubmitting) {
      for (let i = 0; i < 4; i++) {
        if (state[`figures${i}`] !== '') {
          if (state[`figures${i}`] instanceof File) {
            await UploadToS3(state[`figures${i}`], 'PRS2021/speaker', speakerId, `figures${i + 1}`).then((upload) => {
              fileFormData.append(`figures${i + 1}_DUP`, JSON.stringify(upload));
              idx++;
              if (idx === maxFile) {
                resolve(fileFormData);
              }
            });
          }
        }
      }
    } else {
      for (let i = 0; i < state.figures.length; i++) {
        if (state.figures[i] !== '') {
          if (state.figures[i] instanceof File) {
            await UploadToS3(_state.figures[i], 'PRS2021/speaker', speakerId, `figures${i + 1}`).then((upload) => {
              fileFormData.append(`figures${i + 1}_DUP`, JSON.stringify(upload));
              idx++;
              if (idx === maxFile) {
                resolve(fileFormData);
              }
            });
          }
        }
      }
    }

    if (maxFile === idx) resolve(fileFormData);
  });
};
